import Modal from './Modal';
import useUser from '../hooks/useUser';
import { useModal } from "../contexts";
import { useTranslation } from 'react-i18next';

interface Props {
  oauthUrl: string;
  onClose?: () => void;
}

function OAuthModalHubspot(props: Props) {
  const { closeModal } = useModal();
  const { refreshUser } = useUser();
  const { t } = useTranslation();

  function handleInstallIntegration() {
    window.open(props.oauthUrl, "_blank");
    window.addEventListener("focus", getCurrentUserOnFocus);
  }

  async function getCurrentUserOnFocus() {
    window.removeEventListener("focus", getCurrentUserOnFocus);

    refreshUser();
    closeModal(props.onClose);
  }

  return (
    <Modal
      title={t("Connect HubSpot to Portant")}
      subtitle={t("Portant requires access to deals, contacts and companies within your HubSpot account.")}
      className="items-center justify-center"
    >
      <div className="bg-blue text-white font-semibold py-2 px-4 rounded cursor-pointer my-8" onClick={handleInstallIntegration}>
        {t("Connect HubSpot to Portant")}
      </div>
    </Modal>
  );
}

export default OAuthModalHubspot;
